export const getItemsNumber = (activePendantProductVaraintIds: string[]) => { 
  return activePendantProductVaraintIds.length + 1 
}
